import { render } from "./BanksForm.vue?vue&type=template&id=c2c3461c&scoped=true"
import script from "./BanksForm.vue?vue&type=script&lang=js"
export * from "./BanksForm.vue?vue&type=script&lang=js"

import "./BanksForm.vue?vue&type=style&index=0&id=c2c3461c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2c3461c"]])

export default __exports__